import { Util } from '@/modules/util'
import { Request } from '@/classes/Request'

// POST /ajax/order_line_estimate/{district_id}
export const quickpayGoogle = async (
  guid: string,
  payload: Object,
  locale = 'en',
  invitation?: string
): Promise<any> => {
  return new Promise((resolve, reject) => {
    // Explicitly type the Promise
    const req = new Request()
    req
      .post(
        `/ajax/quickpay/google/${guid}?locale=${encodeURIComponent(locale)}` +
          (invitation ? '&invitation=' + encodeURIComponent(invitation) : ''),
        Util.Obj.keysToSnake(payload)
      )
      .then(response => {
        resolve(response.data)
      })
      .catch(err => {
        // A declined payment comes back with an error status and a body that
        // says why. Hand that body to the caller, which already checks `success`,
        // so the payer is told the reason instead of a general failure.
        const body = err?.response?.data
        if (body && typeof body === 'object' && body.success === false) {
          resolve(body)
          return
        }
        reject(new Error('Failed to initiate Google Pay: ' + err)) // Reject with an Error object
      })
  })
}
